var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-main",class:_vm.btnClass,attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.$slots.default || _vm.content)?[_vm._t("default",[_vm._v(_vm._s(_vm.content))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }